import lodash from 'lodash'

export default {
	name : 'menu-more-options',
	props : ['element', 'options', 'topClass', 'side'],
	data () {
		return {
			active : ''
		}
	},
	methods : {
		optionSelected (option) {

			let vm = this

			vm.active = false

			let dataToSend = {
				element : vm.element,
				action  : option.action
			}

			this.$emit('optionSelected', dataToSend);

		}
	}
}


// WEBPACK FOOTER //
// ./src/components/general/menu-more-options/script.js